/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { appRoutes, routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import YesNoSwitch from 'components/input/YesNoSwitch';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import CollegeConfig, { initialCollegeValues } from './components/CollegeConfig';
import { getCollege, updateCollege } from 'app/highSchoolSlice/highSchoolSlice';
import {
  BoolToString,
  checkEnableParseJSON,
  formatBoolean,
  setArrayLength,
} from 'components/helper/helper';
import { debounce } from 'lodash';
import { identifyUserpilot } from 'utils/userpilotClient';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { ExpandMore } from 'screen/activitiesAndHonors/Activities';
import { scrollToObject } from '../highSchool/components/OtherSecondary';
import Grid from '@mui/joy/Grid';
import moment from 'moment';
import { ModalCheckEducationFields } from 'screen/education/common/ModalCheckMissingFields';
import SearchIcon from '@mui/icons-material/Search';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

const number_of_colleges_taken_coursework_options = [
  { value: 0, name: '0 College' },
  { value: 1, name: '1 College' },
  { value: 2, name: '2 College' },
  { value: 3, name: '3 College' },
  { value: 4, name: '4 College' },
  { value: 5, name: '5 College' },
  { value: 6, name: '6 College' },
];

interface Props {}

const CollegeAndUniversity = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  const [showMissingFieldsModal, setShowMissingFieldsModal] = React.useState(false);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const indexExpand = query.get('index');
  const dispatch: any = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  let studentId = getUserId();
  let token = getAccessToken();
  const MIN_YEAR = 2000;
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const information = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const role  = information?.user_role ?? '';
  const isContinuing = React.useRef(false);

  const formik = useFormik({
    initialValues: {
      is_taken_college_courses: '',
      is_currently_taking_courses_in_college: '',
      number_of_college_credits_have_earned: '0',
      number_of_credits_earned_after_school: '0',
      number_of_colleges_taken_coursework: '0',
      colleges_taken_coursework_array: [],
    },
    onSubmit: async (values: any) => {
      try {
        studentId = getUserId();
        token = getAccessToken();
        if (token && studentId) {
          try {
            const navigateAfterSave = isContinuing.current;
            isContinuing.current = false;

            if (navigateAfterSave) {
              // Only validate colleges when the user explicitly clicks Continue/Save
              let isValid = true;
              if (
                values.colleges_taken_coursework_array &&
                values.colleges_taken_coursework_array.length > 0
              ) {
                for (let i = 0; i < values.colleges_taken_coursework_array.length; i++) {
                  let courseItem = values.colleges_taken_coursework_array[i];
                  let fromDate: string = courseItem.fromDate;
                  let toDate: string = courseItem.toDate;
                  let fromYear = moment(fromDate).format('yyyy');
                  let toYear = moment(toDate).format('yyyy');
                  if (!fromDate || !toDate) {
                    isValid = false;
                    expandFold(i + 1, values.colleges_taken_coursework_array.length);
                    break;
                  }

                  if (
                    Number(fromYear) < MIN_YEAR ||
                    Number(toYear) < MIN_YEAR ||
                    !moment(toDate).isAfter(moment(fromDate))
                  ) {
                    isValid = false;
                    expandFold(i + 1, values.colleges_taken_coursework_array.length);
                    break;
                  }

                  if (
                    courseItem.college_grading_system_other &&
                    (courseItem.other_grading_system == null ||
                      courseItem.other_grading_system.length === 0)
                  ) {
                    isValid = false;
                    expandFold(i + 1, values.colleges_taken_coursework_array.length);
                    break;
                  }
                }
              }

              if (!isValid) {
                setTimeout(function () {
                  let btns: any = document.querySelectorAll('.btn-save-info');
                  for (let j = 0; j < btns.length; j++) {
                    btns[j].click();
                  }
                }, 500);
                return;
              }
            }

            setSaving(true);
            const newValues = {
              ...values,
              student_id: studentId,
              is_taken_college_courses: formatBoolean(values.is_taken_college_courses),
              is_currently_taking_courses_in_college: formatBoolean(
                values.is_currently_taking_courses_in_college
              ),
              colleges_taken_coursework_array: JSON.stringify(
                values.colleges_taken_coursework_array
              ),
            };
            identifyUserpilot(studentId, role, {
              name: information?.first_name,
              email: information?.email,
              created_at: information?.created_at,
              college: values?.colleges_taken_coursework_array
                .map((item: any) => item.college_name)
                .join(', '),
              termType: values?.colleges_taken_coursework_array
                .map((item: any) => item.type_of_term_systerm)
                .join(', '),
            });
            await dispatch(updateCollege(newValues));
            setSaving(false);
            if (navigateAfterSave) {
              history.push(appRoutes.futurePlan.path);
            }
          } catch (ex) {
            console.log('Error:', ex);
          }
        } else {
          handleLogout();
        }
      } catch (ex) {
        setSaving(false);
        console.log('Error:');
      }
    },
  });
  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleExpandAll = () => {
    setExpandAll(!expandAll);
    if (!expandAll) {
      setExpandActive(formik.values.colleges_taken_coursework_array.length);
    } else {
      setExpandActive(0);
    }
  };

  const handleExpandActive = (value: any) => {
    value
      ? setExpandActive(Math.abs(expandActive - 1))
      : setExpandActive(Math.abs(expandActive + 1));
  };

  const handleRemoveCollege = (index: number) => {
    const newCollegeData = [...formik.values.colleges_taken_coursework_array];
    newCollegeData.splice(index, 1);
    formik.setFieldValue('colleges_taken_coursework_array', newCollegeData);
    // Update the number of colleges count
    formik.setFieldValue('number_of_colleges_taken_coursework', newCollegeData.length);
  };

  React.useEffect(() => {
    if (expandActive === formik.values.colleges_taken_coursework_array.length) {
      setExpandAll(true);
    }

    if (expandActive === 0) {
      setExpandAll(false);
    }
  }, [expandActive, formik.values.colleges_taken_coursework_array.length]);

  const handleContinue = () => {
    isContinuing.current = true;
    formik.handleSubmit();
  };

  const AutoScrollAndExpand = () => {
    const expandDiv = (divId: string) => {
      let div = document.getElementById(divId);
      if (div) {
        if (div.getAttribute('aria-expanded') === 'false') {
          div.click();
        }
      }
    };
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      if (hash) {
        //console.log('hash:', hash);
        if (hash === 'number_of_colleges_taken_coursework') {
          setTimeout(() => {
            scrollToObject(hash, 200);
          }, 1500);
        } else if (hash.includes('collegeName_')) {
          let str = hash.replaceAll('collegeName_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('fromDate_')) {
          let str = hash.replaceAll('fromDate_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        } else if (hash.includes('toDate_')) {
          let str = hash.replaceAll('toDate_', '');
          let itemIndex = Number(str);
          setTimeout(() => {
            expandDiv(`collegeItem${itemIndex}`);
            setTimeout(() => {
              scrollToObject(hash, 100);
            }, 1500);
          }, 2000);
        }
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.COLLEGE_AND_UNIVERSITY);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      const res = await dispatch(getCollege(studentId));
      if (res.payload) {
        formik.resetForm({
          values: {
            ...formik.values,
            ...res.payload,
            is_taken_college_courses: BoolToString(res.payload.is_taken_college_courses),
            is_currently_taking_courses_in_college: BoolToString(
              res.payload.is_currently_taking_courses_in_college
            ),
            colleges_taken_coursework_array: checkEnableParseJSON(
              res.payload.colleges_taken_coursework_array,
              []
            ),
          },
        });
      }
      setTimeout(() => {
        AutoScrollAndExpand();
      }, 2000);
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    getDetail();
  }, []);

  const expandFold = (num: number, len: number) => {
    let id = `#btn_fold_${num}_${len}[aria-expanded="false"]`;
    let dv: any = document.querySelector(id);
    if (dv) dv.click();
  };

  // Auto save function ==========
  React.useEffect(() => {
    formik.dirty && debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========

  const handleCheckMissingFields = () => {
    setShowMissingFieldsModal(true);
  };

  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.COLLEGE_AND_UNIVERSITY, reviewedAndComplete, setReviewedAndComplete);
  }

  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'College Credits', percentOnProcess: 33, specialId: 'CollegeCourses' },
          { title: 'Colleges', percentOnProcess: 99, specialId: 'Colleges' },
        ]}
        title="Education"
        process={1}
        icon={<StickyNote2OutlinedIcon />}
        isMobile={isMobile}
      />

      <Container
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden',
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%',
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`} id="CollegeCourses">
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Colleges & Universities
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className={`text-dart ${isMobile ? 'fs-6' : 'fs-5'} p-1`}>
                  College Courses or earned College Credit
                </div>
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  label="Have you taken college courses or earned college credit? *"
                  name="is_taken_college_courses"
                  dataUp="cu-taken-college-courses"
                  values={formik.values.is_taken_college_courses}
                  onChange={formik.handleChange}
                  isMissing={!formik.values.is_taken_college_courses}
                  disabled={reviewedAndComplete}
                />
              </Grid>

              {formik.values.is_taken_college_courses === 'true' && (
                <>
                  <Grid xs={12}>
                    <YesNoSwitch
                      label="Are you currently taking courses in college? *"
                      className="coallition-flag py-3"
                      name="is_currently_taking_courses_in_college"
                      dataUp="cu-currently-taking"
                      values={formik.values.is_currently_taking_courses_in_college}
                      onChange={formik.handleChange}
                      isMissing={!formik.values.is_currently_taking_courses_in_college && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>

                  <Grid xs={12}>
                    <TextInput
                      className="coallition-flag py-1"
                      type="number"
                      label="How many college credits have you earned to date? *"
                      name="number_of_college_credits_have_earned"
                      dataUp="cu-credits-earned"
                      values={formik.values.number_of_college_credits_have_earned}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'number_of_college_credits_have_earned',
                          Math.round(e.target.value * 100) / 100
                        );
                      }}
                      decimalStep={0.1}
                      isMissing={(!formik.values.number_of_college_credits_have_earned)&& check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>

                  <Grid xs={12}>
                    <TextInput
                      className="coallition-flag end-flag py-1"
                      type="number"
                      label="How many credits were earned after high school? *"
                      name="number_of_credits_earned_after_school"
                      dataUp="cu-credits-after-hs"
                      values={formik.values.number_of_credits_earned_after_school}
                      onChange={(e) =>
                        formik.setFieldValue(
                          'number_of_credits_earned_after_school',
                          Math.round(e.target.value * 100) / 100
                        )
                      }
                      decimalStep={0.1}
                      isMissing={!formik.values.number_of_credits_earned_after_school && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>

                  <Grid xs={12}>
                    <SelectInput
                      id="number_of_colleges_taken_coursework"
                      logo="span-cm-logo"
                      className="py-1"
                      dataUp="cu-number-of-colleges"
                      form={formik}
                      mdCol="12"
                      option={number_of_colleges_taken_coursework_options}
                      label="Indicate the number of colleges or universities you've taken a course at or received credit from*"
                      name="number_of_colleges_taken_coursework"
                      isSatTest={true}
                      values={formik.values.number_of_colleges_taken_coursework}
                      isMissing={Number(formik.values.number_of_colleges_taken_coursework) === 0 && check}
                      onChange={(e) => {
                        formik.handleChange(e);
                        formik.setFieldValue(
                          'colleges_taken_coursework_array',
                          setArrayLength(
                            formik.values.colleges_taken_coursework_array,
                            e.target.value,
                            initialCollegeValues
                          )
                        );
                      }}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>

                  {formik.values.colleges_taken_coursework_array.length > 0 && (
                    <Grid xs={12}>
                      <div className="d-flex justify-content-end" id="Colleges">
                        <ExpandMore
                          aria-expanded={expandAll}
                          aria-label="show all"
                          onClick={handleExpandAll}
                        >
                          {!expandAll ? (
                            <KeyboardDoubleArrowDownIcon />
                          ) : (
                            <KeyboardDoubleArrowUpIcon />
                          )}
                        </ExpandMore>
                      </div>
                    </Grid>
                  )}

                  <div className="w-100 bg-white py-2 box-collapse rounded-3">
                    {(formik.values.colleges_taken_coursework_array ?? []).map(
                      (item: any, index: number) => (
                        // Plain <div> (not a Joy <Grid xs={12}>): a Grid item here inherits the page
                        // container's spacing as extra padding, which made the gap between colleges
                        // larger than on High Schools / Courses and Grades.
                        <div
                          key={index + '-' + formik.values.colleges_taken_coursework_array?.length}
                        >
                          <CollegeConfig
                            indexExpand={indexExpand}
                            check={check}
                            expandAll={expandAll}
                            handleExpandActive={handleExpandActive}
                            handleSave={(values) => {
                              const newCollegeData: any = [
                                ...formik.values.colleges_taken_coursework_array,
                              ];
                              newCollegeData.splice(index, 1, values);
                              formik.setFieldValue(
                                'colleges_taken_coursework_array',
                                newCollegeData
                              );
                            }}
                            item={item}
                            index={index}
                            indexText={`${index + 1}/${
                              formik.values.colleges_taken_coursework_array.length
                            }`}
                            isMobile={isMobile}
                            onRemove={() => handleRemoveCollege(index)}
                            disabled={reviewedAndComplete}
                          />
                        </div>
                      )
                    )}
                  </div>
                </>
              )}
            </Grid>

            <div
              className={`gm-form-actions border-top ${
                isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'
              } d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}
            >
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div
                className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${
                  isMobile ? '' : 'text-md-end'
                }`}
              >
                <div
                  className={`d-flex ${
                    isMobile ? 'flex-column gap-2' : 'flex-row'
                  } justify-content-center`}
                >
                  <Button
                    variant="primary"
                    type="submit"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto',
                    }}
                  >
                    {saving ? <Spinner size="sm" animation="border" variant="light" /> : 'Save'}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto',
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
      
      {/* Missing Fields Validation Modal */}
      <ModalCheckEducationFields
        show={showMissingFieldsModal}
        onClose={() => setShowMissingFieldsModal(false)}
        data={formik.values}
        page="college"
      />
    </>
  );
};

export default CollegeAndUniversity;
